import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="section-keyboard"
// Handles keyboard navigation for LSAT sections (arrow keys, A-E for answers, F for flag)
export default class extends Controller {
  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    // Only add listener when test has started (will be called from startTest)
    this.keyboardEnabled = false
  }

  disconnect() {
    if (this.keyboardEnabled) {
      document.removeEventListener("keydown", this.boundHandleKeydown)
    }
  }

  enable() {
    if (!this.keyboardEnabled) {
      document.addEventListener("keydown", this.boundHandleKeydown)
      this.keyboardEnabled = true
    }
  }

  disable() {
    if (this.keyboardEnabled) {
      document.removeEventListener("keydown", this.boundHandleKeydown)
      this.keyboardEnabled = false
    }
  }

  handleKeydown(event) {
    const $ = window.$
    if (!$) return

    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    switch (event.keyCode) {
      case 37: // Left arrow
        this.backOne()
        break
      case 39: // Right arrow
        this.forwardOne()
        break
      case 65:
      case 97: // A
        this.selectAnswer(0)
        break
      case 66:
      case 98: // B
        this.selectAnswer(1)
        break
      case 67:
      case 99: // C
        this.selectAnswer(2)
        break
      case 68:
      case 100: // D
        this.selectAnswer(3)
        break
      case 69:
      case 101: // E
        this.selectAnswer(4)
        break
      case 102:
      case 70: // F (flag)
        this.toggleFlag()
        break
    }
  }

  backOne() {
    const $ = window.$
    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    const current = currentQuestion.number
    if (current == 1) return

    const previous = current - 1
    const clickThisBubble = $("#interface-bottom-current-bubble-" + previous + "-yash").parent()
    clickThisBubble.click()
  }

  forwardOne() {
    const $ = window.$
    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    const current = currentQuestion.number
    const lastQuestionNumber = $(".interface-bottom-bubble-yash").length
    if (current == lastQuestionNumber) return

    const next = current + 1
    const clickThisBubble = $("#interface-bottom-current-bubble-" + next + "-yash").parent()
    clickThisBubble.click()
  }

  selectAnswer(index) {
    const $ = window.$
    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    const questionChoice = $(".interface-questions-container-holder-yash")
      .eq(currentQuestion.number - 1)
      .find(".interface-questions-circle-yash")
      .eq(index)

    if (questionChoice.length) {
      questionChoice.click()
    }
  }

  toggleFlag() {
    const $ = window.$
    const currentQuestion = window.currentQuestion
    if (!currentQuestion) return

    const flagElement = $(".interface-questions-container-holder-yash")
      .eq(currentQuestion.number - 1)
      .find(".flag-button-yash")
      .eq(1) // Second flag button (first is fake-flag)

    if (flagElement.length && !flagElement.hasClass("fake-flag-yash")) {
      flagElement.click()
    }
  }
}
